const GlobalConst = {
  TRAIN_PLATFORM_URL: 'http://train.ruijie.com.cn:8088'
}

export default GlobalConst
